import { api } from "@/lib/axios";
import { useMutation } from "@tanstack/react-query";
import { ProfileUpdate } from "../schemas/profile.schema";

export const useProfileUpdate = () => {
  return useMutation({
    mutationFn: async (data: ProfileUpdate) => {
      const response = await api.put(`/api/user/profile`, data);

      if (response.status !== 200) {
        throw new Error("Failed to update profile");
      }

      return response.data;
    },
  });
};
